
import React, { useState, useEffect, useRef } from 'react';
import { Icons } from '../constants';

export type Category = 'lichamelijk' | 'psychisch' | 'gedrag';

export interface Question {
  id: string;
  text: string;
  category: Category;
}

export const QUESTIONS: Question[] = [
  // Lichamelijk
  { id: 'l1', category: 'lichamelijk', text: 'Lichamelijke klachten door werkdruk' },
  { id: 'l2', category: 'lichamelijk', text: 'Steeds zeer moe' },
  { id: 'l3', category: 'lichamelijk', text: 'Hoofdpijn' },
  { id: 'l4', category: 'lichamelijk', text: 'Hartkloppingen / druk op borst' },
  { id: 'l5', category: 'lichamelijk', text: 'Slecht inslapen' },
  { id: 'l6', category: 'lichamelijk', text: 'Slecht doorslapen' },
  { id: 'l7', category: 'lichamelijk', text: 'Nek- of schouderklachten' },
  { id: 'l8', category: 'lichamelijk', text: 'Rugpijn' },
  { id: 'l9', category: 'lichamelijk', text: 'Spierpijn' },
  { id: 'l10', category: 'lichamelijk', text: 'Duizeligheid of trillen' },
  { id: 'l11', category: 'lichamelijk', text: 'Ademhalingsklachten' },
  { id: 'l12', category: 'lichamelijk', text: 'Verhoogde bloeddruk' },
  { id: 'l13', category: 'lichamelijk', text: 'Maag- en darmklachten' },
  { id: 'l14', category: 'lichamelijk', text: 'Probleem met eten/gewicht' },
  { id: 'l15', category: 'lichamelijk', text: 'Overmatig zweten' },
  { id: 'l16', category: 'lichamelijk', text: 'Snel infecties' },
  { id: 'l17', category: 'lichamelijk', text: 'Huidproblemen' },
  { id: 'l18', category: 'lichamelijk', text: 'Trillen' },
  { id: 'l19', category: 'lichamelijk', text: 'Wit of rood zien' },
  { id: 'l20', category: 'lichamelijk', text: 'Probleem met lichaamstemp.' },
  // Psychisch
  { id: 'p1', category: 'psychisch', text: 'Psychische klachten door werkdruk' },
  { id: 'p2', category: 'psychisch', text: 'Veel piekeren' },
  { id: 'p3', category: 'psychisch', text: 'Zorgen maken / angstig' },
  { id: 'p4', category: 'psychisch', text: 'Ik ben gespannen' },
  { id: 'p5', category: 'psychisch', text: 'Lusteloos, somber, huilen' },
  { id: 'p6', category: 'psychisch', text: 'Prikkelbaar / snel boos' },
  { id: 'p7', category: 'psychisch', text: 'Machteloos voelen' },
  { id: 'p8', category: 'psychisch', text: 'Stemmingswisselingen' },
  { id: 'p9', category: 'psychisch', text: 'Rusteloos / gejaagd' },
  { id: 'p10', category: 'psychisch', text: 'Onzeker / verlies zelfvertrouwen' },
  { id: 'p11', category: 'psychisch', text: 'Slechte concentratie' },
  { id: 'p12', category: 'psychisch', text: 'Zaken sneller vergeten' },
  { id: 'p13', category: 'psychisch', text: 'Niet kunnen ontspannen' },
  { id: 'p14', category: 'psychisch', text: 'Geen zin in werk' },
  { id: 'p15', category: 'psychisch', text: 'Afwezig / er niet bij zijn' },
  { id: 'p16', category: 'psychisch', text: 'Controle kwijt voelen' },
  { id: 'p17', category: 'psychisch', text: 'Niet kunnen relativeren' },
  { id: 'p18', category: 'psychisch', text: 'Ik ben cynisch' },
  { id: 'p19', category: 'psychisch', text: 'Drukte niet verdragen' },
  { id: 'p20', category: 'psychisch', text: 'Niet tegen verandering kunnen' },
  { id: 'p21', category: 'psychisch', text: 'Mezelf niet herkennen' },
  // Gedrag
  { id: 'g1', category: 'gedrag', text: 'Gedrag veranderd door werkdruk' },
  { id: 'g2', category: 'gedrag', text: 'Meer roken / drinken / snoepen' },
  { id: 'g3', category: 'gedrag', text: 'Meer of minder eten' },
  { id: 'g4', category: 'gedrag', text: 'Minder zin in intimiteit' },
  { id: 'g5', category: 'gedrag', text: 'Ontevreden over prestaties' },
  { id: 'g6', category: 'gedrag', text: 'Moeite met complexe tekst' },
  { id: 'g7', category: 'gedrag', text: 'Meer fouten maken' },
  { id: 'g8', category: 'gedrag', text: 'Sociale contacten vermijden' },
  { id: 'g9', category: 'gedrag', text: 'Weinig tijd voor plezier' },
  { id: 'g10', category: 'gedrag', text: 'Dingen op automatische piloot' },
  { id: 'g11', category: 'gedrag', text: 'Vaker te laat komen' },
  { id: 'g12', category: 'gedrag', text: 'Vroeger van werk vertrekken' },
  { id: 'g13', category: 'gedrag', text: 'Weinig initiatief nemen' },
  { id: 'g14', category: 'gedrag', text: 'Thuis niets meer doen' },
  { id: 'g15', category: 'gedrag', text: 'Ik werk chaotischer' },
  { id: 'g16', category: 'gedrag', text: 'Overdag in slaap vallen' },
];

const CATEGORIES: { id: Category; label: string; description: string }[] = [
  { id: 'lichamelijk', label: '1. Lichamelijke klachten', description: 'Fysieke signalen van stress.' },
  { id: 'psychisch', label: '2. Psychische klachten', description: 'Mentale en emotionele gesteldheid.' },
  { id: 'gedrag', label: '3. Veranderingen in gedrag', description: 'Aanpassingen in je dagelijks doen en laten.' },
];

const StressCheck: React.FC = () => {
  const [step, setStep] = useState<number>(0); // 0 = start, 1 = input, 2 = result
  const [currentCategoryIndex, setCurrentCategoryIndex] = useState<number>(0);
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());
  const containerRef = useRef<HTMLDivElement>(null);

  // Luister naar de reset event van buitenaf (bijv. vanaf Contact pagina)
  useEffect(() => {
    const handleReset = () => {
      setStep(0);
      setSelectedIds(new Set());
      setCurrentCategoryIndex(0);
    };

    window.addEventListener('stressCheckReset', handleReset);
    return () => window.removeEventListener('stressCheckReset', handleReset);
  }, []);

  useEffect(() => {
    if (step === 2) {
      const score = selectedIds.size;
      let fullReport = `KIS STRESS-CHECK RAPPORT\nTotaalscore: ${score} klachten\n\n`;
      
      CATEGORIES.forEach(cat => {
        fullReport += `--- ${cat.label.toUpperCase()} ---\n`;
        const catQuestions = QUESTIONS.filter(q => q.category === cat.id);
        catQuestions.forEach(q => {
          const answer = selectedIds.has(q.id) ? '[JA]' : '[NEE]';
          fullReport += `${answer} ${q.text}\n`;
        });
        fullReport += '\n';
      });

      localStorage.setItem('liza_stress_score', score.toString());
      localStorage.setItem('liza_stress_full_report', fullReport);
      
      // Dispatch event voor het contactformulier
      window.dispatchEvent(new CustomEvent('stressCheckCompleted', { 
        detail: { score, report: fullReport } 
      }));
    }
  }, [step, selectedIds]);

  const toggleOption = (id: string) => {
    const next = new Set(selectedIds);
    if (next.has(id)) {
      next.delete(id);
    } else {
      next.add(id);
    }
    setSelectedIds(next);
  };

  const getResult = (score: number) => {
    if (score === 0) return { title: "Gezond evenwicht", desc: "Je herkent op dit moment geen klachten. Je bent in balans. Blijf goed voor jezelf zorgen.", color: "text-green-600", bg: "bg-green-50/50" };
    if (score <= 5) return { title: "Lichte spanning", desc: "Je ervaart incidenteel stressklachten. Dit is normaal, maar vraagt wel om aandacht voor je rustmomenten.", color: "text-blue-600", bg: "bg-blue-50/50" };
    if (score <= 10) return { title: "Signaal voor actie", desc: "Je verliest momenteel meer energie dan je opbouwt. Het is raadzaam om preventieve maatregelen te nemen.", color: "text-amber-600", bg: "bg-amber-50/50" };
    if (score <= 15) return { title: "Serieus risico", desc: "Je lichaam geeft duidelijke waarschuwingssignalen. Begeleiding is aan te bevelen om uitval te voorkomen.", color: "text-orange-600", bg: "bg-orange-50/50" };
    if (score <= 20) return { title: "Mogelijk overspannen", desc: "De druk is te hoog geworden. Je vertoont duidelijke symptomen van overbelasting. Professionele hulp is noodzakelijk.", color: "text-red-600", bg: "bg-red-50/50" };
    return { title: "Hoogstwaarschijnlijk burn-out", desc: "Je bevindt je in een kritieke fase. Rust en gespecialiseerde begeleiding zijn direct noodzakelijk om verder herstel mogelijk te maken.", color: "text-red-700", bg: "bg-red-100/50" };
  };

  const scrollToTop = () => {
    if (containerRef.current) {
      const offset = 100; // Ruimte voor de navbar of padding
      const elementPosition = containerRef.current.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const handleScrollToContact = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const nextCategory = () => {
    if (currentCategoryIndex < CATEGORIES.length - 1) {
      setCurrentCategoryIndex(currentCategoryIndex + 1);
      scrollToTop();
    } else {
      setStep(2);
      scrollToTop();
    }
  };

  const prevCategory = () => {
    if (currentCategoryIndex > 0) {
      setCurrentCategoryIndex(currentCategoryIndex - 1);
      scrollToTop();
    } else {
      setStep(0);
      scrollToTop();
    }
  };

  const score = selectedIds.size;
  const result = getResult(score);
  const currentCat = CATEGORIES[currentCategoryIndex];

  return (
    <div 
      ref={containerRef}
      className="bg-white rounded-[3rem] p-6 md:p-16 shadow-2xl border border-accent-light max-w-6xl mx-auto relative overflow-hidden transition-all duration-500"
    >
      
      {/* Header sectie */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-12 gap-4 border-b border-accent-light pb-8">
        <div>
          <h4 className="text-3xl font-serif text-primary leading-tight">
            {step === 2 ? 'Analyse Resultaten' : 'Stress-Inventarisatie'}
          </h4>
          <p className="text-gray-600 font-light text-sm mt-1">
            {step === 0 && 'Ontdek hoe stress je welzijn beïnvloedt.'}
            {step === 1 && `Stap ${currentCategoryIndex + 1} van ${CATEGORIES.length}: ${currentCat.label}`}
            {step === 2 && 'Op basis van je antwoorden hebben we de volgende indicatie samengesteld.'}
          </p>
        </div>
        {(step === 1 || step === 2) && (
          <div className="bg-primary/5 px-6 py-3 rounded-2xl border border-primary/10">
             <span className="text-primary text-[10px] font-bold uppercase tracking-widest">
               Totaal: {score} klachten
             </span>
          </div>
        )}
      </div>

      {step === 0 && (
        <div className="py-12 text-center animate-in fade-in duration-700">
          <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center text-primary mx-auto mb-8">
             <Icons.Leaf />
          </div>
          <p className="text-gray-500 font-light mb-12 leading-relaxed max-w-2xl mx-auto">
            We onderzoeken je klachten om een globaal beeld van je toestand te krijgen. Vul in welk fysieke of psychische klachten je de afgelopen maand had en of je gedrag de laatste tijd door stress is veranderd.
          </p>
          <button 
            onClick={() => { setStep(1); setCurrentCategoryIndex(0); }}
            className="bg-primary text-white px-12 py-5 rounded-full font-bold uppercase tracking-[0.3em] text-[10px] hover:shadow-xl hover:-translate-y-1 transition-all duration-300 shadow-lg shadow-primary/20"
          >
            Start de check
          </button>
        </div>
      )}

      {step === 1 && (
        <div className="animate-in fade-in slide-in-from-right-4 duration-500 key={currentCat.id}">
          <div className="relative mb-12">
            <div className="mb-8">
              <h5 className="text-xl font-serif text-primary flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-accent-light flex items-center justify-center text-primary text-sm font-bold">{currentCategoryIndex + 1}</span>
                {currentCat.label}
              </h5>
              <p className="text-gray-600 text-xs mt-2 ml-11">{currentCat.description}</p>
            </div>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 ml-0 md:ml-11">
              {QUESTIONS.filter(q => q.category === currentCat.id).map((q) => {
                const isSelected = selectedIds.has(q.id);
                return (
                  <button
                    key={q.id}
                    onClick={() => toggleOption(q.id)}
                    className={`text-left p-4 rounded-xl border transition-all duration-200 flex items-center justify-between group ${
                      isSelected 
                        ? 'bg-primary/5 border-primary shadow-sm' 
                        : 'bg-liza-bg border-transparent hover:border-primary/20 hover:bg-white'
                    }`}
                  >
                    <span className={`text-[12px] font-medium leading-tight transition-colors ${isSelected ? 'text-primary' : 'text-gray-600'}`}>
                      {q.text}
                    </span>
                    <div className={`w-5 h-5 rounded-full border flex-shrink-0 flex items-center justify-center transition-all ${
                      isSelected 
                        ? 'bg-primary border-primary text-white' 
                        : 'bg-white border-gray-200 text-transparent'
                    }`}>
                      <Icons.Check />
                    </div>
                  </button>
                );
              })}
            </div>
          </div>

          <div className="mt-16 pt-12 border-t border-accent-light/50 flex flex-col sm:flex-row items-center justify-between gap-6">
            <button 
              onClick={prevCategory}
              className="text-gray-500 hover:text-primary text-[10px] font-bold uppercase tracking-[0.2em] transition-colors"
            >
              Vorige stap
            </button>
            
            <div className="flex gap-2">
              {CATEGORIES.map((_, i) => (
                <div key={i} className={`w-2 h-2 rounded-full transition-all duration-300 ${i === currentCategoryIndex ? 'bg-primary w-6' : 'bg-accent-light'}`}></div>
              ))}
            </div>

            <button 
              onClick={nextCategory}
              className="bg-primary text-white px-12 py-5 rounded-full font-bold uppercase tracking-[0.3em] text-[10px] hover:shadow-2xl hover:-translate-y-1 transition-all duration-500 shadow-xl shadow-primary/20"
            >
              {currentCategoryIndex === CATEGORIES.length - 1 ? 'Bekijk resultaat' : 'Volgende stap'}
            </button>
          </div>
        </div>
      )}

      {step === 2 && (
        <div className={`rounded-3xl p-10 md:p-16 animate-in fade-in slide-in-from-bottom-8 duration-700 ${result.bg}`}>
          <div className="text-center max-w-3xl mx-auto">
            <span className="text-accent font-bold tracking-[0.4em] text-[10px] uppercase mb-4 block">Je Persoonlijke Rapport</span>
            <div className="text-7xl font-serif text-primary mb-6">{score} <span className="text-xl">signalen</span></div>
            <h3 className={`text-4xl font-serif mb-8 ${result.color}`}>{result.title}</h3>
            <p className="text-gray-700 font-light text-lg mb-12 leading-relaxed italic">
              "{result.desc}"
            </p>
            
            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <a 
                href="#contact" 
                onClick={handleScrollToContact}
                className="bg-primary text-white px-12 py-5 rounded-full font-bold uppercase tracking-[0.2em] text-[10px] hover:shadow-xl transition-all shadow-lg shadow-primary/20"
              >
                Plan Gratis Adviesgesprek
              </a>
              <button 
                onClick={() => { setStep(1); setCurrentCategoryIndex(0); scrollToTop(); }}
                className="bg-white text-primary border border-primary/20 px-12 py-5 rounded-full font-bold uppercase tracking-[0.2em] text-[10px] hover:bg-liza-bg transition-all"
              >
                Aanpassingen maken
              </button>
              <button 
                onClick={() => { 
                  setStep(0); 
                  setSelectedIds(new Set()); 
                  setCurrentCategoryIndex(0);
                  localStorage.removeItem('liza_stress_score'); 
                  localStorage.removeItem('liza_stress_full_report'); 
                  window.dispatchEvent(new CustomEvent('stressCheckReset')); 
                  scrollToTop(); 
                }}
                className="text-gray-500 hover:text-primary transition-colors text-[9px] uppercase tracking-[0.2em] font-bold"
              >
                Volledig wissen
              </button>
            </div>

            <div className="mt-16 pt-10 border-t border-accent-light flex flex-col items-center gap-4">
              <p className="text-[10px] text-gray-500 uppercase tracking-widest leading-relaxed">
                Dit resultaat is een indicatie. Voor een medische diagnose adviseren wij je altijd contact op te nemen met je huisarts.
              </p>
              <div className="w-12 h-1 bg-accent-light rounded-full"></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StressCheck;
